// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__Cp7r4","content":"ManualTimeModal_content__1LZzE"};